import { USER } from '../constants/user.constants';
import { authHeader } from '../helpers/auth-header';
import { history } from '../helpers/history';
import { store } from '../store/configureStore';

export function logout() {
  // remove user from local storage to log user out
  // localStorage.removeItem("user");
  store.dispatch({ type: USER.LOGOUT_SUCCESS });
  localStorage.clear();
  history.push('/login');
  window.location.reload();
}

function handleResponse(response: any) {
  return response.text().then((text: any) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        logout();
        // window.location.reload(true);
      }
      let error = undefined;
      if (data) {
        error = {
          message: data.message || response.statusText,
          wrongPassword: data.wrong_password,
          wrongEmail: data.wrong_email,
          wrongName: data.wrong_name,
        };
      } else {
        error = '';
      }
      return Promise.reject(error);
    }

    return data;
  });
}
